import React from 'react';
import { useDeepCompareEffect } from 'react-use';
import { useDispatch } from 'react-redux';
import { useTableState } from '@dotone/react-ui-core/hooks';
import { AccessHistoryTable } from '@dotone/react-ui-core';
import { useCurrentUser, useShallowEqualSelector } from '@hooks';
import { fetchAccessHistories, distrustAccessHistory } from '@actions';

const UserAccessHistory = (props) => {
  const dispatch = useDispatch();
  const { currentUser, locale } = useCurrentUser();
  const [tableProps, setTableProps] = useTableState();
  const { data, pagination, isLoading } = useShallowEqualSelector(
    ({ accessHistoryList }) => accessHistoryList
  );
  const { page, perPage } = tableProps;
  const query = { page, perPage, locale };

  const handleDistrust = (id) => {
    dispatch(distrustAccessHistory(id));
  };

  useDeepCompareEffect(() => {
    if (currentUser.id) {
      dispatch(fetchAccessHistories(query));
    }
  }, [dispatch, currentUser.id, query]);

  return (
    <AccessHistoryTable
      loading={isLoading}
      tableProps={tableProps}
      data={data}
      pagination={pagination}
      onTableChange={setTableProps}
      onDistrust={handleDistrust}
      {...props}
    />
  );
};

export default UserAccessHistory;
